export const Config = {
    omnitureTrackingDevUrl:  'https://assets.adobedtm.com/571f1a0c43d6/79575aef67c5/launch-1f5b2cb7a84e-development.min.js',
    omnitureTrackingProdUrl:  'https://assets.adobedtm.com/571f1a0c43d6/79575aef67c5/launch-59cc01cb0c94.min.js',
    cookieConsentPopupDevGuid: '6a44666b-8d0f-4eb4-b5b3-4a06e9dba2f7-test',
    cookieConsentPopupProdGuid: '6a44666b-8d0f-4eb4-b5b3-4a06e9dba2f7',
    cookiePopupUrl: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
    }
    
    